import { useLocation } from "react-router";
import React, { useState, useEffect, useRef } from "react";
import jsPDF from "jspdf";
import axios from "axios";
import "../modal.css";
import Table from "./../Theme/Table.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../Spinner";
import { Button } from "react-bootstrap";
import { Checkbox, Modal } from "antd";

const CompanyTransactionsList = () => {
  const location = useLocation();
  let [loading, setLoading] = useState(true);
  const [transactions, setTransactions] = useState([]);

  const getTransactions = async () => {
    try {
      const res = await axios.get("transactions/");
      // Map names for driver only; we will not expose passenger info
      const mapped = res.data.map((t) => {
        const driverName = `${t.driver?.firstName || ''} ${t.driver?.lastName || ''}`.trim();
        return {
          ...t,
          driver: { ...t.driver, name: driverName },
        };
      });
      setTransactions(mapped);
      setLoading(false);
    } catch (err) {
      notifyError();
    }
  };

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  useEffect(() => {
    getTransactions();
  }, [location.key]);

  // Columns without passenger section
  const columns = React.useMemo(
    () => [
      {
        Header: "Trip",
        columns: [
          { Header: "Id", accessor: "id" },
          { Header: "Date", accessor: "createdAt" },
        ],
      },
      {
        Header: "Driver",
        columns: [
          { Header: "Name", accessor: "driver.name" },
          { Header: "Phone", accessor: "driver.phoneNumber" },
        ],
      },
      {
        Header: "Financials",
        columns: [
          { Header: "Total Price (ETB)", accessor: "actualPrice" },
          { Header: "Revenue (ETB)", accessor: "revenue" },
        ],
      },
    ],
    []
  );

  // Export modal state
  const [isModalVisible, setIsModalVisible] = useState(false);
  const showModal = () => setIsModalVisible(true);
  const handleCancel = () => setIsModalVisible(false);

  // Flattened columns for export
  const columns_expo = React.useMemo(
    () => [
      { Header: "Id", accessor: "id" },
      { Header: "Date", accessor: "createdAt" },
      { Header: "Driver Name", accessor: "driver.name" },
      { Header: "Driver Phone", accessor: "driver.phoneNumber" },
      { Header: "Price", accessor: "actualPrice" },
      { Header: "Revenue", accessor: "revenue" },
    ],
    []
  );

  const [selectedColumns, setSelectedColumns] = useState(columns_expo.map((c) => c.Header));

  function handleColumnToggle(columnHeader) {
    setSelectedColumns((prev) =>
      prev.includes(columnHeader)
        ? prev.filter((col) => col !== columnHeader)
        : [...prev, columnHeader]
    );
  }

  function handleExportClick(transactions, columns) {
    const doc = new jsPDF();

    doc.setFontSize(16);
    doc.text(`Company Transactions`, 105, 15, { align: "center" });
    doc.setFontSize(10);

    const tableBody = transactions.map((t) =>
      columns
        .filter((col) => selectedColumns.includes(col.Header))
        .map((col) => {
          const keys = col.accessor.split(".");
          let data = t;
          for (const k of keys) {
            data = data?.[k];
          }
          return data ?? "";
        })
    );

    const head = [columns.filter((c) => selectedColumns.includes(c.Header)).map((c) => c.Header)];

    doc.autoTable({ head, body: tableBody });
    doc.save("company_transactions.pdf");
  }

  const handleOkModal = () => {
    setIsModalVisible(false);
    handleExportClick(transactions, columns_expo);
  };

  return (
    <div className="content-wrappers" style={{ marginTop: "-40px" }}>
      <div className="content-wrappers">
        <br />
        <br />
        <ToastContainer />

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h3 className="card-title">Company Transactions</h3>
                    <Button onClick={() => setIsModalVisible(true)}>Export</Button>
                  </div>

                  <Modal
                    style={{ marginTop: "60px" }}
                    title="Select Columns to Export"
                    visible={isModalVisible}
                    onOk={handleOkModal}
                    onCancel={handleCancel}
                    footer={[
                      <Button key="cancel" onClick={handleCancel}>
                        Cancel
                      </Button>,
                      <Button style={{ marginLeft: "10px" }} key="ok" type="primary" onClick={handleOkModal}>
                        OK
                      </Button>,
                    ]}
                  >
                    <div style={{ marginBottom: "20px" }}>
                      {columns_expo.map((column) => (
                        <div key={column.Header} style={{ marginBottom: "10px" }}>
                          <Checkbox
                            checked={selectedColumns.includes(column.Header)}
                            onChange={() => handleColumnToggle(column.Header)}
                            style={{ marginRight: "10px", fontSize: "16px" }}
                          >
                            {column.Header}
                          </Checkbox>
                        </div>
                      ))}
                    </div>
                  </Modal>

                  <div className="card-body">
                    {loading && (
                      <div>
                        <Spinner />
                      </div>
                    )}
                    {!loading && <Table columns={columns} data={transactions} />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default CompanyTransactionsList;
